<style>.studio-card {
    padding: 1em;
    border-radius: 10px;
    background-color: #678052;
    width: 100%;
    transition: 0.5s;
    display: flex;
    flex-direction: row;
    white-space: nowrap;
    height: 182px;
}
.studio-card:hover {
	cursor: pointer;
    box-shadow: 0 0 3px black;
    margin-top: -10px;
}
.title {
    color: #FFEDD9;
    font-family: "DIN Condensed";
    font-size: 24px;
    font-weight: medium;
    letter-spacing: 0;
    line-height: 24px;
    text-align: center;
    margin: 0 !important;
    text-transform: uppercase;
}
.subtitle {
    color: #FFEDD9;
    font-family: 'ivypresto-display', serif !important;
    font-size: 24px;
    font-style: italic;
    font-weight: 100;
    letter-spacing: 0;
    line-height: 24px;
    margin-bottom: 10px !important;
}
.city {
    color: #FFEDD9;
    font-family: Manrope;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 1px;
    line-height: 14px;
    margin-bottom: 5px !important;
    text-transform: uppercase;
}
.icon {
	width: 100%;
    height: auto;
    background-position: center center;
    background-size: contain;    
}
.text-wrapper {
	display: flex;
    flex-direction: column;
    text-align: left;
    padding-left: 20px;
    justify-content: flex-end;
    align-items: flex-start;
}</style>
<template><router-link :to="{ path: `${studio}` }" custom v-slot="{ navigate }">
    <div @click="navigate" @keypress.enter="navigate" role="link" class="zoezi-product-card studio-card">
        <div class="icon" :style="iconStyle"></div>
        <div class="text-wrapper">
            <h4 class="title">{{title}}</h4>
            <p class="subtitle">{{subtitle}}</p>
            <p class="city">{{city}}</p>
        </div>
    </div>
</router-link></template>
<script>export default {
    props: {
        sigill: {
        	title: 'Sigill',
            type: Image,
            default: 'e6626512-78b7-4255-ad83-ee1602d141a3'
        },
        title: {
            title: 'Studionamn',
            type: String,
            default: 'Klicka här'
        },
        subtitle: {
            title: 'Adress',
            type: String,
            default: 'Klicka här'
        },
        city: {
            title: 'Ort',
            type: String,
            default: 'Klicka här'
        },
        studio: {
            title: 'Studions sida',
            type: String,
            default: '/studios/'
        }
    },
    computed: {
        iconStyle() {
          return {
            'background-image': `url('https://boka.motionstudios.se/api/utils/file/download?key=${this.sigill}&size=100')`
          };
        }
	}
}</script>